import { GraphQLNonNull, GraphQLList } from 'graphql'
import { Context } from '../shared'
import {
  sourceNameType,
  SourceName,
  SourceNameQueryArgs,
  sourceNameQueryArgs
} from '../types/source-names'
import { ContrastGraphQLFieldConfig } from '..'

export const normalizeSourceName = ({
  id,
  name,
  start,
  expiration,
  expired,
  cidr_blocks: cidrBlocks,
  last_modified: modified
}) => ({
  id,
  name,
  start,
  expiration,
  expired,
  cidrBlocks,
  modified: new Date(modified)
})

export const sourceName: ContrastGraphQLFieldConfig<
  any,
  Context,
  SourceNameQueryArgs,
  SourceName[]
> = {
  description: 'Get a source name by ID',
  type: new GraphQLNonNull(new GraphQLList(new GraphQLNonNull(sourceNameType))),
  args: sourceNameQueryArgs,
  async resolve(_source, args, context) {
    const { organizationID, id } = args
    const { connector } = context
    const { source_name: sourceName } = await connector.get(
      `/${organizationID}/protect/sourcename/${id}`
    )
    return [normalizeSourceName(sourceName)]
  }
}
